import { render, staticRenderFns } from "./MetricForm.vue?vue&type=template&id=5a8bf733&"
import script from "./MetricForm.vue?vue&type=script&lang=js&"
export * from "./MetricForm.vue?vue&type=script&lang=js&"
import style0 from "./MetricForm.vue?vue&type=style&index=0&id=5a8bf733&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports